// AuthContext.tsx
import { User } from '@/types/user';
import { createContext } from 'react';

interface AuthContextType {
  user: User | null;
  loading: boolean;
  refreshAuth: () => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType>({
  user: null,
  loading: true,
  refreshAuth: () => Promise.resolve(),
  logout: () => Promise.resolve(),
});
